import * as React from 'react';
import {DrawerDesktop} from './Drawer.desktop';
import {DrawerBottomSheet} from './Drawer.bottomsheet';
import {DrawerConfig} from './DrawerConfig';
import {useShouldDisplayBottomSheet} from '../bottom-sheet/useShouldDisplayBottomSheet';

export const Drawer = DrawerConfig.createView((props) => {
  const shouldDisplayBottomSheet = useShouldDisplayBottomSheet('drawer');

  return shouldDisplayBottomSheet ? (
    <DrawerBottomSheet {...props} />
  ) : (
    <DrawerDesktop {...props} />
  );
});
